import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import { useHudStore } from "@/domains/hud/store";

export default () => {
  const setIsShow = useHudStore((state) => state.setIsShow);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Hud.SetHudShow,
      (state: typeof RegionShared.Cef.Requests.SetHudShowRequest) => {
        setIsShow(state);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Hud.SetHudShow);
    };
  }, []);
};
